/**
 *
 * @author Matthew Rawson @ 29/03/2018 14:16
 * @description
 * @notes
 *
 */
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import moment from "moment-timezone"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import {DatePicker} from "@irati/ui/src/FormItem"
import {Label} from "@irati-web/insights/src/ui/FormItem"
import {Para} from "@irati-web/insights/src/ui/Labels"
import {shouldStartAtFieldBeEnabled} from "@irati-web/insights/src/helpers/schedule"


export const PROPERTY = "startAt"
export const schema = (formatMessage) => Validation.date(formatMessage({id: "insights.validation.required"}))


class StartAt extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    hint: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    name: PROPERTY,
    label: null,
    hint: null,
    disabled: false
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  handleChange = (value) => {
    /** Dispatch changes */
    const {onChange, schedule, name} = this.props
    onChange(schedule, name, value.clone().utc().format())
  }


  render() {
    const idNamespace = id("StartAt", this.props)
    const {formatMessage, schedule, name, label, hint, disabled} = this.props
    const value = moment(get(schedule, PROPERTY))
    const isDisabled = !shouldStartAtFieldBeEnabled(schedule) || disabled
    const intlLabel = label || formatMessage({id: `insights.fields.schedule.${PROPERTY}.label`})
    const intlHint = hint || formatMessage({id: `insights.fields.schedule.${PROPERTY}.hint`})
    const datePickerLabel = <Fragment> <Label bold>{intlLabel}</Label> <Para>{intlHint}</Para></Fragment>

    return (
      <DatePicker
        id={idNamespace}
        label={datePickerLabel}
        name={name}
        disabled={isDisabled}
        showTimeSelect
        value={value}
        onChange={this.handleChange}
        minDate={new Date()}
        timeIntervals={15}
        validation={schema(formatMessage)} />
    )
  }
}

export default injectIntl(StartAt)
